import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import logo from '../assets/mrtp-logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Column 1: About */}
          <div>
            <Link to="/" className="inline-block mb-6 group">
              <div className="bg-white rounded-lg p-3 inline-block transition-all duration-300 group-hover:shadow-lg group-hover:scale-105 shadow-md">
                <img 
                  src={logo}
                  alt="MRTP SARL"
                  className="h-10 w-auto"
                />
              </div>
            </Link>
            <div className="text-gray-400 text-sm space-y-2">
              <p className="text-white font-semibold">MRTP SARL</p>
              <div className="space-y-1">
                <p>5 Lot. Côte Meunière</p>
                <p>04370 Villars-Colmars, France</p>
              </div>
              <a 
                href="mailto:Contact@artduchalet.com" 
                className="text-[#c4d600] hover:text-[#b0c200] transition-colors inline-block mt-2"
              >
                Contact@artduchalet.com
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="font-bold mb-4 text-[#c4d600]">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/votre-projet" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Votre projet
                </Link>
              </li>
              <li>
                <Link to="/votre-maison" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Votre maison
                </Link>
              </li>
              <li>
                <Link to="/nos-terrains" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Nos terrains
                </Link>
              </li>
              <li>
                <Link to="/nos-agences" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Nos agences
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div>
            <h3 className="font-bold mb-4 text-[#c4d600]">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/mentions-legales" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-400 hover:text-[#c4d600] transition-colors text-sm">
                  Gestion des cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & Social */}
          <div>
            <h3 className="font-bold mb-4 text-[#c4d600]">Suivez-nous</h3>
            <div className="flex space-x-4 mb-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-700 hover:bg-[#c4d600] flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-700 hover:bg-[#c4d600] flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-700 hover:bg-[#c4d600] flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-gray-700 hover:bg-[#c4d600] flex items-center justify-center transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
            <Link
              to="/contact"
              className="inline-block bg-[#c4d600] text-gray-800 px-6 py-2 rounded hover:bg-[#b0c200] transition-colors text-sm font-semibold"
            >
              Nous contacter
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} MRTP SARL. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;